import { lazy, Suspense, useEffect, useState } from "react";
import { OCEAN_GL } from "@/lib/perf";
import { ErrorBoundary } from "@/components/z6/ErrorBoundary";
import { Contours } from "@/components/z6/Motifs";
import { WaterRipple } from "@/components/z6/WaterRipple";

const OceanCanvas = lazy(() => import("@/components/z6/OceanCanvas"));

export const OceanFallback = () => (
  <div data-testid="ocean-fallback" aria-hidden className="ocean-fallback pointer-events-none fixed inset-0 -z-10 overflow-hidden">
    <div className="ocean-flow" />
    <div className="ocean-flow ocean-flow-b" />
    <div data-testid="ocean-caustics" className="ocean-caustic" />
    <div className="ocean-caustic ocean-caustic-b" />
    <div className="ocean-blob ocean-blob-a" />
    <div className="ocean-blob ocean-blob-b" />
    <div className="ocean-blob ocean-blob-c" />
    <Contours className="absolute inset-0 h-full w-full opacity-[0.12]" color="#0F8A96" seed={7} lines={14} />
  </div>
);

const Lite = () => <><OceanFallback /><WaterRipple /></>;

// Below ~30fps for 2 straight seconds (tab visible) -> drop to the lightweight water.
const useSlow = (on) => {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    if (!on) return undefined;
    let raf, frames = 0, t0 = performance.now(), bad = 0;
    const tick = (now) => {
      frames += 1;
      if (now - t0 >= 1000) {
        bad = !document.hidden && frames < 30 ? bad + 1 : 0;
        frames = 0; t0 = now;
        if (bad >= 2) { setSlow(true); return; }
      }
      raf = requestAnimationFrame(tick);
    };
    const start = setTimeout(() => { t0 = performance.now(); raf = requestAnimationFrame(tick); }, 2500);
    return () => { clearTimeout(start); cancelAnimationFrame(raf); };
  }, [on]);
  return slow;
};

export const Ocean = () => {
  const slow = useSlow(OCEAN_GL);
  if (!OCEAN_GL || slow) return <Lite />;
  return (
    <ErrorBoundary fallback={<Lite />}>
      <Suspense fallback={<OceanFallback />}>
        <OceanCanvas />
      </Suspense>
    </ErrorBoundary>
  );
};
